import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { track } from "./adapters/analytics";

// Sends "screen_view" on every route change (the funnel is a single-page app, so there are no page loads
// for analytics to catch). /grammarTest/3 → { screen: "grammarTest", index: 3, path: "/grammarTest/3" }.
// Through track(), so it goes wherever track() goes (Mixpanel in the real funnel).
export function useScreenView() {
  const { pathname } = useLocation();
  const last = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (last.current === pathname) return; // StrictMode re-runs, redirects to the same path
    const previous = last.current;
    last.current = pathname;
    const [screen = "start", index] = pathname.replace(/^\/+/, "").split("/");
    track("screen_view", {
      screen,
      ...(index !== undefined && { index: Number(index) }),
      path: pathname,
      ...(previous && { from: previous }),
    });
  }, [pathname]);
}
